import useMediaQuery, { BELOW_SIDEBAR_QUERY } from './useMediaQuery';

// The size of a button that sits in the page shell: the large size while the
// admin sidebar is on screen and the compact one while it is a drawer, where
// vertical space is tight. There are only these two sizes.
// The shell is also rendered on the server, so it starts large and takes the
// real answer once mounted.
function useShellButtonSize() {
  const isDrawerMode = useMediaQuery(BELOW_SIDEBAR_QUERY, {
    afterMount: true,
  });
  return isDrawerMode ? 'compact' : 'large';
}

export default useShellButtonSize;
